


















import { isDark } from '@bkwld/light-or-dark'
import { getColorNameFromHex } from 'library/helpers/ui'
export default

	props: block: Object

	# Get the index of the block
	inject: blockIndex: default: 0

	computed:

		# Make the backgroundColor, which may not contain a leading '#'
		# https://github.com/presseddigital/colorit/pull/35
		backgroundColor: ->
			return unless color = @block.backgroundColor
			return if color == 'transparent'
			if color.match(/^(\#|rgb)/i) then color else '#' + color

		# Look up color name (ie. 'light-green') from @backgroundColor hex
		backgroundColorName: -> getColorNameFromHex @backgroundColor

		# Is it a dark background color
		isDark: -> isDark @backgroundColor if @backgroundColor

		# Root classes
		wrapperClasses: -> [
			if @isDark then 'fg-light' else 'fg-dark'
			"bg-#{@backgroundColorName}"
		]

		columnsClasses: -> [
			# Max-width class with -5050 suffix (see CSS comments)
			"#{@block.maxWidth or 'max-w'}-5050"
			if @block.mobileLayout == 'right' then 'mobile-layout-right' else 'mobile-layout-left'
		]

		columns: -> @block.columns or []

		# Get the left and right columns.  Not guaranteed to exist or be in any particular order.
		leftColumn: -> @columns.find (column) -> column.__typename == 'blocks_wrapper5050LeftColumn_BlockType'
		rightColumn: -> @columns.find (column) -> column.__typename == 'blocks_wrapper5050RightColumn_BlockType'

